"use client"

/**
 * How sure Leo is, as a word, with the reason one click away.
 *
 * High, Medium or Low on its own is a claim; the info icon says what it rests
 * on: the words in the question, Leo's reading of the whole thing, the
 * director's mapping, what people did with it before.
 */

import * as React from "react"

import { Badge } from "@/components/ui/badge"
import { Button } from "@/components/ui/button"
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover"
import { confidenceText } from "@/lib/exam-categories"

export function ConfidenceBadge({
  confidence,
  why,
  className,
}: {
  confidence: number
  /** The reasons, one line each. Absent: just the word. */
  why?: readonly string[]
  className?: string
}) {
  return (
    <span className={`inline-flex items-center gap-0.5 ${className ?? ""}`}>
      <Badge variant="secondary">{confidenceText(confidence)}</Badge>
      {why && why.length > 0 ? (
        <Popover>
          <PopoverTrigger asChild>
            <Button
              type="button"
              variant="ghost"
              size="icon-xs"
              className="text-muted-foreground"
              aria-label={`Why ${confidenceText(confidence).toLowerCase()}`}
            >
              <i className="fa-light fa-circle-info text-xs" aria-hidden="true" />
            </Button>
          </PopoverTrigger>
          <PopoverContent align="start" className="w-72 text-sm">
            <p className="m-0 mb-1.5 font-medium text-foreground">Why {confidenceText(confidence).toLowerCase()}</p>
            <ul className="m-0 flex list-none flex-col gap-1.5 p-0 text-xs leading-snug text-muted-foreground">
              {why.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </PopoverContent>
        </Popover>
      ) : null}
    </span>
  )
}
